import { useToast } from "@/components/ui/use-toast";
import SuccessModel from "@/components/_module/signup/successModel";
import { useAuth } from "@/context/auth-context";
import useSendPhoneVerificationCode from "@/features/register/hooks/useSendPhoneVerificationCode";
import useValidateTwoFactorAuthenticationCode from "@/features/register/hooks/useValidate2FACode";
import { useState } from "react";
import EnterPhoneCode from "../Home/card/view/_components/EnterPhoneCode";
import { useLoaderData } from "@tanstack/react-router";
import { queryClient } from "@/query-client";
import { UserInformation } from "@/api/signin";
import { userKeys } from "@/features/auth/keys";

const TelCode = () => {
	const { toast } = useToast();
	const { user } = useAuth();

	const validateCode = useValidateTwoFactorAuthenticationCode();
	const resendCode = useSendPhoneVerificationCode();
	const [code, setCode] = useState<string>("");
	const { location_id } = useLoaderData({ from: "__root__" });

	const handleSubmitCode = (code: number) => {
		validateCode.mutate(
			{
				payload: {
					email: user.email,
					verification_code: code,
					phone_number: user.phone_number,
					global_country_id: user.global_country_id,
					phone_global_country_id: user.global_country_id,
					type: "2fa",
				},
				locationId: location_id,
			},
			{
				onSuccess: () => {
					queryClient.setQueryData(
						userKeys.userInformation(),
						(oldData: UserInformation) => {
							return {
								...oldData,
								has_verified_phone_number: true,
							};
						},
					);
					queryClient.refetchQueries({
						queryKey: userKeys.userInformation(),
					});
				},
				onError: (error) => {
					toast({
						title: "Verification Failed",
						description: error.message,
						variant: "destructive",
					});
					setCode("");
				},
			},
		);
	};

	const handleResendCode = () => {
		resendCode.mutate(
			{
				global_country_id: user.global_country_id,
				phone_number: user.phone_number,
			},
			{
				onSuccess: () => {
					toast({
						title: "Code Resent",
						description: "A new verification code has been sent to your phone.",
					});
				},
				onError: (error) => {
					toast({
						title: "Verification Failed",
						description: error.message,
						variant: "destructive",
					});
					setCode("");
				},
			},
		);
	};

	return (
		<>
			<EnterPhoneCode
				code={code}
				setCode={setCode}
				phone={user.phone_number ?? ""}
				onSubmit={handleSubmitCode}
				onResendCode={handleResendCode}
				submitMutationStatus={validateCode.status}
				resendMutationStatus={resendCode.status}
			/>
			<SuccessModel isOpen={validateCode.isSuccess} onOpenChange={() => {}} />
		</>
	);
};

export default TelCode;
